import { render, staticRenderFns } from "./AnswerMore.vue?vue&type=template&id=59db14a0&scoped=true&"
import script from "./AnswerMore.vue?vue&type=script&lang=js&"
export * from "./AnswerMore.vue?vue&type=script&lang=js&"
import style0 from "./AnswerMore.vue?vue&type=style&index=0&id=59db14a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db14a0",
  null
  
)

export default component.exports